import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { fetchAssetData } from '../../../Service/APIService';
import Auth from '../../../shared/Auth';
import CustomWidget from '../../Custom/CustomWidget';

const INIT_STATE = {
  WTI: 0,
  OTI: 0,
  AmbientTemp: 0,
  OilLevel: 'NA',
  TapPosition: 'NA',
  ExpectedVoltage: 'NA',
  ActualVoltage: 'NA',
  reportedOn: '-',
};

const ChartLiveReadings = ({ id }) => {
  const [values, setValues] = useState(INIT_STATE);

  const bindData = async () => {
    fetchAssetData(id)
      .then((response) => {
        const { statusCode, result } = response.data;
        const data = statusCode === 200 ? result : {};
        const {
          WTI,
          OTI,
          AmbientTemp,
          OilLevel,
          TapPosition,
          ExpectedVoltage,
          ActualVoltage,
          ReportedDateTime,
        } = data.dataStream[0];
        setValues({
          WTI: WTI || 0,
          OTI: OTI || 0,
          AmbientTemp: AmbientTemp || 0,
          OilLevel: OilLevel || '-',
          TapPosition,
          ExpectedVoltage,
          ActualVoltage,
          reportedOn:
            ReportedDateTime === null
              ? '-'
              : ReportedDateTime.replace('_', ' ').substring(
                  0,
                  ReportedDateTime.length - 3
                ),
        });
      })
      .catch((error) => {
        setValues(INIT_STATE);
        console.log(error);
      });
  };

  useEffect(() => {
    async function fetchData() {
      const checkToken = await Auth();
      if (checkToken) {
        bindData();
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchOilLevelColor = (OilLevel) => {
    switch (OilLevel.toUpperCase()) {
      case 'NORMAL':
        return '#54a75b';
      case 'LOW':
        return '#943b2f';
      case 'HIGH':
        return '#943b2f';
      default:
        return '#87CEEB';
    }
  };

  return (
    <Row id="tab1">
      <Col lg={6} md={6} sm={6}>
        <CustomWidget
          size={12}
          id={'chrtTemp'}
          title={'Temperature and Oil Level'}
        >
          <Row>
            <Col lg={6} md={6} sm={6} style={{ minHeight: '180px' }}>
              <div style={{ padding: '5%' }}>
                <div
                  style={{
                    width: '120px',
                    height: '120px',
                    textAlign: 'center',
                  }}
                >
                  <CircularProgressbar
                    value={values.WTI}
                    text={`${values.WTI}`}
                  />
                  <div className="font-weight-bold">WTI(°C)</div>
                </div>
              </div>
            </Col>
            <Col lg={6} md={6} sm={6} style={{ minHeight: '180px' }}>
              <div style={{ padding: '5%' }}>
                <div
                  style={{
                    width: '120px',
                    height: '120px',
                    textAlign: 'center',
                  }}
                >
                  <CircularProgressbar
                    styles={buildStyles({
                      pathColor: '#54a75b',
                    })}
                    value={values.OTI}
                    text={`${values.OTI}`}
                  />
                  <div className="font-weight-bold">OTI(°C)</div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={6} md={6} sm={6} style={{ minHeight: '180px' }}>
              <div style={{ padding: '5%' }}>
                <div
                  style={{
                    width: '120px',
                    height: '120px',
                    textAlign: 'center',
                  }}
                >
                  <CircularProgressbar
                    styles={buildStyles({
                      pathColor: '#6c2871',
                    })}
                    value={values.AmbientTemp}
                    text={`${values.AmbientTemp}`}
                  />
                  <div className="font-weight-bold">Surface(°C)</div>
                </div>
              </div>
            </Col>

            <Col lg={6} md={6} sm={6} style={{ minHeight: '180px' }}>
              <div style={{ padding: '5%' }}>
                <div
                  style={{
                    width: '120px',
                    height: '120px',
                    textAlign: 'center',
                  }}
                >
                  <div
                    className="font-weight-bold"
                    style={{ fontSize: '24px' }}
                  >
                    Oil Level:
                  </div>
                  <br></br>
                  <div
                    className="font-weight-bold"
                    style={{
                      fontSize: '24px',
                      color: fetchOilLevelColor(values.OilLevel),
                    }}
                  >
                    {values.OilLevel}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </CustomWidget>
      </Col>
      <Col lg={6} md={6} sm={6}>
        <CustomWidget size={12} id={'chrtPositions'} title={'Tap Position'}>
          <Row style={{ display: 'flex', justifyContent: 'center' }}>
            <Col
              lg={6}
              md={6}
              sm={6}
              style={{ padding: '1%', minWidth: '60%' }}
            >
              <div className="info-box">
                <div className="info-box-icon bg-aqua">
                  <i className="fa fa-sort clr-white"></i>
                </div>

                <div className="info-box-content">
                  <span className="info-box-text">Tap Position</span>
                  <span className="info-box-number" id="spanTap">
                    {values.TapPosition}
                  </span>
                </div>
              </div>
            </Col>
          </Row>
          <Row style={{ display: 'flex', justifyContent: 'center' }}>
            <Col
              lg={6}
              md={6}
              sm={6}
              style={{ padding: '1%', minWidth: '60%' }}
            >
              <div className="info-box">
                <div className="info-box-icon bg-aqua">
                  <i className="fa fa-plug clr-white"></i>
                </div>

                <div className="info-box-content">
                  <span className="info-box-text">Expected Voltage(HV/LV)</span>
                  <span className="info-box-number" id="spanExpVol">
                    {' '}
                    {values.ExpectedVoltage}
                  </span>
                </div>
              </div>
            </Col>
          </Row>
          <Row style={{ display: 'flex', justifyContent: 'center' }}>
            <Col
              lg={6}
              md={6}
              sm={6}
              style={{ padding: '1%', minWidth: '60%' }}
            >
              <div className="info-box">
                <div className="info-box-icon bg-aqua">
                  <i className="fa fa-plug clr-white"></i>
                </div>

                <div className="info-box-content">
                  <span className="info-box-text">Actual Voltage(V)</span>
                  <span className="info-box-number" id="spanActVol">
                    {values.ActualVoltage}
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </CustomWidget>
      </Col>
    </Row>
  );
};

export default ChartLiveReadings;
